import { Haptics, ImpactStyle } from '@capacitor/haptics';
import store from 'store2';

const STORAGE_KEY_HAPTIC_IS_DISABLED = 'haptic_is_disabled';

export function toggleHaptic() {
	return store.local.set(
		STORAGE_KEY_HAPTIC_IS_DISABLED,
		!store.local.get(STORAGE_KEY_HAPTIC_IS_DISABLED)
	);
}

export function isHapticEnabled() {
	return !store.local.get(STORAGE_KEY_HAPTIC_IS_DISABLED) && process.env.MOB_APP_BUILD;
}

export function hapticLight() {
	if (isHapticEnabled()) {
		Haptics.impact({
			style: ImpactStyle.Light,
		});
	}
}

export function hapticMedium() {
	if (isHapticEnabled()) {
		Haptics.impact({
			style: ImpactStyle.Medium,
		});
	}
}

export function hapticHeavy() {
	if (isHapticEnabled()) {
		Haptics.impact({
			style: ImpactStyle.Heavy,
		});
	}
}

export function hapticVibrate() {
	if (isHapticEnabled()) {
		Haptics.vibrate();
	}
}
